import {REPORT_EARNED_CAB} from '/enum/records.enum';

export default {
  reportName: REPORT_EARNED_CAB,
};
